import React, { Component } from 'react';
import { DashboardLayout } from '../../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';

class UserPaymentMethod extends Component {
    render() {
        return (<DashboardLayout>
            <section className="payment-method">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">Payment Method</h2>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box py-1">
                            <div className="check-card d-flex"> 
                                <div className="custom-control custom-checkbox mr-lg-5 mr-3">
                                    <input type="checkbox" className="custom-control-input" id="customControlAutosizing"/>
                                    <label className="custom-control-label" htmlFor="customControlAutosizing"><img  width="80px" height="50px" src="/images/mastercard.png"/></label>
                                </div>
                                
                                <div className="custom-control custom-checkbox mr-lg-5 mr-3">
                                    <input type="checkbox" className="custom-control-input" id="customControlAutosizing1"/>
                                    <label className="custom-control-label" htmlFor="customControlAutosizing1"><img  width="50px" height="50px" src="/images/visa.png"/></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                        <div className="col-md-12">
                            <div className="post-box mb-4">
                                <div className="master-card">                                    
                                    <div className="accordion" id="accordionExample">
                                        <div className="card">
                                            <div className="card-header" id="headingOne">
                                                
                                                <button  className="btn w-100 text-left page-subtitle px-0" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    Master Card <i className="fas fa-plus float-right mt-2"></i>
                                                    </button>
                                                
                                            </div>

                                            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                                <div className="card-body">
                                                    <form>
                                                        <div className="row">
                                                            <div className="col-md-4 mb-3">
                                                                <label>Master Card</label>
                                                                <input type="text" className="form-control"  placeholder="125XXXXXXX32"/>
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <label>Name of card holder</label>
                                                                <input type="text"className="form-control" placeholder="Albert Dell"/>
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                
                                                                <button className="btn bg-primary rounded-circle float-right px-2 py-1"><img width="15px" src="/images/svg/trash.svg"/></button>
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <label>Expire Date</label>
                                                                <div className="form-row">
                                                                    <div className="col">
                                                                        <select id="inputState" className="form-control">
                                                                            <option selected>06</option>
                                                                            <option>07</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="col">
                                                                        <select id="inputState" className="form-control">
                                                                            <option selected>06</option>
                                                                            <option>07</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <label>Security Code</label>
                                                                <input type="text"className="form-control" placeholder="xxxx"/>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div className="custom-control custom-radio">
                                                                    <input type="radio" className="custom-control-input" id="customControlValidation2" name="radio-stacked" required />
                                                                    <label className="custom-control-label" htmlFor="customControlValidation2">Make it Default</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="post-box mb-4">
                                <div className="master-card">                                    
                                    <div className="accordion" id="accordionExample">
                                        <div className="card">
                                            <div className="card-header" id="headingOne">
                                                <button  className="btn w-100 text-left page-subtitle px-0" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    Visa Card <i className="fas fa-plus float-right mt-2"></i>
                                                    </button>
                                            </div>

                                            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                                <div className="card-body">
                                                    <form>
                                                        <div className="row">
                                                            <div className="col-md-4 mb-3">
                                                                <label>Master Card</label>
                                                                <input type="text" className="form-control"  placeholder="125XXXXXXX32"/>
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <label>Name of card holder</label>
                                                                <input type="text"className="form-control" placeholder="Albert Dell"/>
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                
                                                                <button className="btn bg-primary rounded-circle float-right px-2 py-1"><img width="15px" src="/images/svg/trash.svg"/></button>
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <label>Expire Date</label>
                                                                <div className="form-row">
                                                                    <div className="col">
                                                                        <select id="inputState" className="form-control">
                                                                            <option selected>06</option>
                                                                            <option>07</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="col">
                                                                        <select id="inputState" className="form-control">
                                                                            <option selected>06</option>
                                                                            <option>07</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4 mb-3">
                                                                <label>Security Code</label>
                                                                <input type="text"className="form-control" placeholder="xxxx"/>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div className="custom-control custom-radio">
                                                                    <input type="radio" className="custom-control-input" id="customControlValidation3" name="radio-stacked" required />
                                                                    <label className="custom-control-label" htmlFor="customControlValidation3">Make it Default</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>    

            </section> 
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);
const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(UserPaymentMethod);